// extracted by mini-css-extract-plugin
export default {"badgeContainerLight":"AndrewNationBadge_badgeContainerLight__AagIa","badgeContainerDark":"AndrewNationBadge_badgeContainerDark__IDTHq"};